export default __webpack_public_path__ + "static/media/pac-2.e17d9863.png";